<template>
  <div class="video" v-if="datas.videoUrl && datas.videoUrl != ''" :class="{ 'noMargin': datas.isMargin == 'F' }"
    :style="styleBg">
    <div class="video-box" :style="radiusStyle" ref="video">
      <video ref="myVideo" class="video-js vjs-big-play-centered" x5-playsinline playsinline webkit-playsinline>
        <source :src="datas.videoUrl" />
      </video>
    </div>


  </div>
</template>

<script>
  import Video from 'video.js'
  import 'video.js/dist/video-js.css'
  Vue.prototype.$video = Video
  export default {
    props: ["datas"],
    data() {
      return {
        myPlayer: "",
        videoHeight: ''
      };
    },
    computed: {
      styleBg() {
        return `background:${this.datas.bgColor};`
      },
      radiusStyle() {
        let style = '';
        if (this.datas.showRadius) {
          style += ` border-radius: 8px;`
        }
        return style
      }
    },
    methods: {
      initVideo() {
        //初始化视频方法 
        this.myPlayer = this.$video(this.$refs.myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: this.datas.autoplay ? 'muted' : false,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          poster: this.datas.cover,
          //设置视频播放器的显示宽度（以像素为单位）
          width: this.$refs.video.clientWidth,
          height: this.videoHeight
          //设置视频播放器的显示高度（以像素为单位）

        });
      },
    },
    mounted() {
      this.$nextTick(() => {
        let margin = 0
        if (this.datas.isMargin == "T") {
          margin = 30
        }
        if (this.datas.showType == "vertical") {
          if (this.datas.isMargin == "T") {
            this.videoHeight = `636.5`;
          } else {
            this.videoHeight = `666.5`;
          }
        } else {

          if (this.datas.showSize == 'default') {
            this.videoHeight = (window.innerWidth - margin) * 3 / 4;
          } else if (this.datas.showSize == 'large') {
            this.videoHeight = (window.innerWidth - margin) * 9 / 16; 
          } else {
            this.videoHeight = 290 - margin;
          }
        }
        if (this.datas.videoUrl != '') {
          this.initVideo()
        }

      })

    }


  };
</script>
<style lang="less" scoped>
  @import url("~@/styles/mixin.less");

  .video {
    box-sizing: border-box;
    padding: 15px;

    .video-js {
      width: 100%;

    }

    .video-box {
      overflow: hidden;
    }

    &.noMargin {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/polymerization/video.vue